module.exports = __webpack_public_path__ + "static/media/message1.f6ba471b.svg";